'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import UIToolBar from 'UIComponents/nav/UIToolBar';
import UIToolBarGroup from 'UIComponents/nav/UIToolBarGroup';
import UILink from 'UIComponents/link/UILink';
import Big from 'UIComponents/elements/Big';
import UIModal from 'UIComponents/dialog/UIModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class FullscreenModal extends Component {
  constructor(props) {
    super(props);
    this.renderHeader = this.renderHeader.bind(this);
  }
  renderHeader() {
    return /*#__PURE__*/_jsxs(UIToolBar, {
      use: "tabs",
      className: "fullscreen-header",
      children: [/*#__PURE__*/_jsx(UIToolBarGroup, {
        minWidth: "33%",
        children: /*#__PURE__*/_jsx(UIBackButton, {
          className: "close-button",
          "data-test-id": "fullscreen-modal-back-button",
          children: /*#__PURE__*/_jsx(UILink, {
            className: "m-left-0",
            onClick: this.props.onClose,
            children: /*#__PURE__*/_jsx(Big, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "ContentComponents.fullscreenModal.back"
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx(UIToolBarGroup, {
        children: this.props.headerContent
      }), /*#__PURE__*/_jsx(UIToolBarGroup, {
        minWidth: "33%",
        children: this.props.headerButton
      })]
    });
  }
  render() {
    return /*#__PURE__*/_jsx(UIModal, Object.assign({
      use: "fullscreen",
      className: this.props.className
    }, this.props.modalProps, {
      children: /*#__PURE__*/_jsxs("div", {
        className: "fullscreen-modal-contents",
        children: [this.renderHeader(), /*#__PURE__*/_jsx("div", {
          className: "modal-content",
          children: this.props.children
        })]
      })
    }));
  }
}
FullscreenModal.defaultProps = {
  modalProps: {}
};
FullscreenModal.propTypes = {
  headerButton: PropTypes.node,
  headerContent: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  modalProps: PropTypes.object
};
export default FullscreenModal;